import HundredBricksAPIError from '@lib/hundredBricksAPI/HundredBricksAPIError';
class AddressError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('AddressError', ...args);
    }
}
export default AddressError;
